// reducers.js
import {
  SET_WALLPAPER_TRANSPARENCY,
  SET_WALLPAPER_RESIZING,
  SET_WALLPAPER_OVERLAY_COLOR,
  SET_BG_WALLPAPER,
  SET_IS_PATTERN,
  SET_SEGMENT_BG_COLOR,
  SET_CURRENT_BG,
  SET_SELECTED_COLOR_TYPE,
  SET_PATTERN_COLOR,
  SET_BG_GRADIENT,
  UPDATE_WALLPAPER_INITAL_STATE,
  RESET_WHEEL_BG_TO_INITIAL_STATE,
  // Add other action types
} from '../types';

const initialState = {
  wallpaperTransparency: 100,
  wallpaperResizing: 20,
  wallpaperOverlayColor: '#ffffff',
  bgWallpaper: 'linear-gradient(45deg, #F7FED5, #CCFEFF, #FDCFFE, #F5EEDE)',
  isPattern: false,
  segmentBgColor: '#ffffff',
  currentBg: 3,
  selectedColorType: 1,
  patternColor: '#000000',
};

const wheelWallpaperReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WALLPAPER_TRANSPARENCY:
      return { ...state, wallpaperTransparency: action.payload };
    case SET_WALLPAPER_RESIZING:
      return { ...state, wallpaperResizing: action.payload };
    case SET_WALLPAPER_OVERLAY_COLOR:
      return { ...state, wallpaperOverlayColor: action.payload, currentBg: 1 };
    case SET_BG_WALLPAPER:
      return {
        ...state,
        bgWallpaper: action.payload.value,
        isPattern: action.payload.isPattern,
        currentBg: action.payload.isPattern ? 1 : 2,
      };
    case SET_BG_GRADIENT:
      return {
        ...state,
        bgWallpaper: action.payload.value,
        currentBg: 3,
      };
    case SET_IS_PATTERN:
      return { ...state, isPattern: action.payload };
    case SET_SEGMENT_BG_COLOR:
      return { ...state, segmentBgColor: action.payload, currentBg: 0 };
    case SET_CURRENT_BG:
      return { ...state, currentBg: action.payload };
    case SET_SELECTED_COLOR_TYPE:
      return { ...state, selectedColorType: action.payload, currentBg: 1 };
    case SET_PATTERN_COLOR:
      return { ...state, patternColor: action.payload, currentBg: 1 };
    case UPDATE_WALLPAPER_INITAL_STATE:
      return action.payload;
    case RESET_WHEEL_BG_TO_INITIAL_STATE: // New case for resetting to initial state
      return { ...initialState };
    // Add other cases
    default:
      return state;
  }
};

export default wheelWallpaperReducer;
